module.exports = __webpack_public_path__ + "9546c44e445d8df9a8fbebb1e79d23b4.svg";